import { closeIcon } from "../../../assets/svgs/icons/icons.svg";
import useTranslation from "../../../hooks/useTranslation";
import styles from "./InscriptionAnnuleeNotification.module.scss";

type Props = {
  isNotifVisible: boolean,
  setIsNotVisible: (newState: boolean) => void
}

export default function InscriptionAnnuleeNotification(props: Props) {
  const { isNotifVisible, setIsNotVisible } = props;
  const { t } = useTranslation();

  function hideNotification() {
    setIsNotVisible(false);
  }

  return (
    <>
      {isNotifVisible && (
        <article className={styles.inscriptionAnnuleeNotification}>
          <header className={styles.inscriptionAnnuleeNotification__header}>
            <h1>{t('components.notifications.registrationCancelled')}</h1>
            <button type="button" onClick={hideNotification}>
              {closeIcon}
            </button>
          </header>
          <main className={styles.inscriptionAnnuleeNotification__main}>
            {/* <p>L'ensemble de vos données ont été supprimées.</p> */}
            <p>
              {t('components.inscriptionAnnuleeNotification.subTitle')}
            </p>
          </main>
        </article>
      )}
    </>
  );
}
